export enum BotCardType {
    youtubeCard = 'youtubeCard',
    iframeCard = 'iframeCard',
    vimeoCard = 'vimeoCard',
    imageCard = 'imageCard',
    buttonsCard = 'buttonsCard',
    htmlCard = 'htmlCard',
    loadingCard = 'loadingCard'
}

export type YoutubeCard = {
    type: BotCardType.youtubeCard,
    data: {
        id: string,
        cssClass: string
    }
}
export type LoadingCard = {
    type: BotCardType.loadingCard;
    data: {
        icon: string;
        text: string;
        cssClass: string;


    };
};

export type HtmlCard = {
    type: BotCardType.htmlCard,
    data: {
        html: string,
        cssClass: string
    }
}

export type IframeCard = {
    type: BotCardType.iframeCard,
    data: {
        url: string,
        cssClass: string
    }
}

export type VimeoCard = {
    type: BotCardType.vimeoCard,
    data: {
        id: string,
        hash: string,
        cssClass: string
    }
}

export type ImageCard = {
    type: BotCardType.imageCard,
    data: {
        src: string,
        altText: string,
        cssClass: string
    }
}

export type ButtonCard = {
    type: BotCardType.buttonsCard,
    data: {
        buttons: ({ text: string, className: string, onClick: string } | string)[],
        cssClass: string
    }
}